<template>
  <Select
    :items="bancos"
    :selectedItem="filter.banco"
    :label="filtro.name"
    :searchPlaceholder="filtro.placeholder"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
    :fixo="filtro.fixo"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        banco: {
          id: "",
          name: "",
        },
      },
      bancos: this.filtro.opcoes || [],
    };
  },
  methods: {
    atualizar(banco) {
      this.filter.banco = banco;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.banco.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.banco.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.bancos, this.filter.banco);
  }
}
</script>
